"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChevronRightIconSmall = ChevronRightIconSmall;
exports.default = ChevronRightIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ChevronRightIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M8.71457 20L16.8 12L8.71457 4L7.46665 5.44589L14.0905 12L7.46665 18.5541L8.71457 20Z",
    fill: "currentColor"
  }));
}
function ChevronRightIconSmall(props) {
  return (0, _core.jsx)(ChevronRightIcon, _extends({
    size: "small"
  }, props));
}